import React, { useState, useEffect } from "react";
import "./AcademyGallery.css";
import { useUser } from "../context/UserContext";
import Swal from "sweetalert2";

const AcademyGallery = () => {
  const [gallery, setGallery] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const { selectedCenter } = useUser();
  const entriesPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const token = localStorage.getItem('auth-token');
  useEffect(() => {
    if (!selectedCenter) {
      alert("Please select a center.");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_API_ACADEMY_GALLERY}/${selectedCenter}/gallery`;

    const fetchGallery = async () => {
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch gallery images");
        }

        const result = await response.json();
        if (result.success && result.data.academyGalleryEntities) {
          setGallery(result.data.academyGalleryEntities);
        } else {
          throw new Error("No gallery data available");
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchGallery();
  }, [selectedCenter]);

  const handleUploadClick = () => {
    setShowModal(true);
  };
  const fetchGallery = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_ACADEMY_GALLERY}/${selectedCenter}/gallery`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch gallery images");

      const result = await response.json();
      if (result.success && result.data.academyGalleryEntities) {
        setGallery(result.data.academyGalleryEntities);
      }
    } catch (error) {
      console.error(error.message);
    }
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (!file.type.startsWith("image/")) {
        alert("Please select an image file (JPG, PNG, etc.)");
        return;
      }

      setSelectedFile(file);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      Swal.fire({
        title: 'Error!',
        text: 'No file selected. Please select an image to upload.',
        icon: 'error',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    setShowModal(false);

    const formData = new FormData();
    const academyGalleryForm = { academyId: selectedCenter };
    formData.append("academyGalleryForm", new Blob([JSON.stringify(academyGalleryForm)], { type: "application/json" }));
    formData.append("images", selectedFile);

    try {
      const response = await fetch(process.env.REACT_APP_API_UPLOAD_GALLERY, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.status === 413) {
        Swal.fire({
          title: 'Error!',
          text: '413 Request Entity Too Large – The image is too large. Please try a smaller file.',
          icon: 'error',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 4000,
        });
        return;
      }

      if (!response.ok) {
        const errText = await response.text();
        Swal.fire({
          title: 'Error!',
          text: `Upload failed: ${errText || response.statusText}`,
          icon: 'error',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 4000,
        });
        return;
      }

      const result = await response.json();
      if (result.success) {
        await fetchGallery();
        Swal.fire({
          icon: 'success',
          title: 'Uploaded!',
          text: 'Image uploaded successfully.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        closeModal(); 
      } else {
        Swal.fire({
          title: 'Error!',
          text: result.message || 'Upload failed',
          icon: 'error',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      }
      closeModal(); 
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error!',
        text: error.message || 'Something went wrong while uploading.',
        icon: 'error',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
      });
      closeModal(); 
    }
    closeModal(); 
    setShowModal(false);
    setSelectedFile(null);
  };
  const closeModal = () => {
    setShowModal(false);
    setSelectedFile(null);
  
    const fileInput = document.getElementById("gallery-fileInput");
    if (fileInput) fileInput.value = "";
  };
  
  const totalEntries = gallery.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const indexOfFirstEntry = (currentPage - 1) * entriesPerPage + 1;
  const indexOfLastEntry = Math.min(currentPage * entriesPerPage, totalEntries);
  const currentEntries = gallery.slice(indexOfFirstEntry - 1, indexOfLastEntry);
  const handlePageClick = (pageNumber) => {
    if (pageNumber !== '...') setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');

      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (!result.isConfirmed) return;

      const response = await fetch(
        `${process.env.REACT_APP_API_DELETE_GALLERY_IMAGE}?galleryImageId=${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      setGallery((prevGallery) => prevGallery.filter((image) => image.id !== id));

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The image has been deleted successfully.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error!",
        text: error.message || "There was an error deleting the academy.",
        icon: "error",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };


  return (
    <div className="enrollment-container">
      <button className="uploadbutton" onClick={handleUploadClick}>
        <span className="uploadbutton__icon">
          <svg strokeLinejoin="round" strokeLinecap="round" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path fill="none" d="M0 0h24v24H0z" stroke="none"></path>
            <path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"></path>
            <path d="M9 15l3 -3l3 3"></path>
            <path d="M12 12l0 9"></path>
          </svg>
        </span>
        <span className="uploadbutton__text">Upload</span>
      </button>
      <div className="tt-table-container" style={{ overflowY: 'auto' }}>
        <table className="tt-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentEntries.map((image) => (
              <tr key={image.id}>
                <td>
                  <img
                    src={image.imageUrl}
                    alt="Gallery Image"
                    style={{ width: "200px", height: "200px", objectFit: "cover" }}
                  />
                </td>
                <td>
                  <button className="delete-button" onClick={() => handleDelete(image.id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z" />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div
          className="gallery-modal-overlay"
          onClick={closeModal}
        >
          <div
            className="gallery-modal-content"
            onClick={e => e.stopPropagation()}
          >
            <h2 className="gallery-modal-title">Upload Image</h2>

            <label htmlFor="gallery-fileInput" className="gallery-file-label">
              Choose File
            </label>
            <input
              id="gallery-fileInput"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />

            <p className="gallery-file-name">
              {selectedFile ? selectedFile.name : "No file chosen"}
            </p>

            <div className="gallery-modal-actions">
              <button
                className="gallery-upload-btn"
                onClick={handleUpload}
              >
                Upload
              </button>
              <button
                className="gallery-cancel-btn"
                onClick={() => {
                  setShowModal(false);
                  setSelectedFile(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button className="prev-button" onClick={handlePrevPage} disabled={currentPage === 1}>
          Previous
        </button>
        {renderPagination()}
        <button className="next-button" onClick={handleNextPage} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>

    </div>
  );
};

export default AcademyGallery;
